import { render, staticRenderFns } from "./Attestation.vue?vue&type=template&id=c328d58e&scoped=true&"
import script from "./Attestation.vue?vue&type=script&lang=js&"
export * from "./Attestation.vue?vue&type=script&lang=js&"
import style0 from "./Attestation.vue?vue&type=style&index=0&id=c328d58e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c328d58e",
  null
  
)

export default component.exports